angular.module('impactx.rfx').controller('RFXItemCompareValueCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'ToolbarService',
    'TranslationService',
    '$mdDialog',
    RFXItemCompareValueCtrl
]);

function RFXItemCompareValueCtrl($scope, $routeParams, dataGen, ToolbarService, TranslationService, $mdDialog) {
    var self = this;
    var dialogItem = self.item;
    self.item = JSON.parse(JSON.stringify(self.item));
    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = TranslationService.get("save");
    $scope.requiredLabel = TranslationService.get("required");

    self.abort = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        dataGen.postAsForm({}, {rfqiId: self.item.rfqiId, value: self.item.currentValueAsInteger.value}, "/rfx/itemcompare/savevalue").then(function () {
            $mdDialog.hide();
        });
    };
}